// Markdown from the AI notes, summaries and reports is written with an <h1> title and <h2>/<h3>
// sections, but it is always shown inside a page that already has its <h1>. Each page must have
// exactly one, and headings may not skip levels, so the markdown's outline is moved under the
// page's with aria-level: the title becomes a level-2 heading and sections level 3. The tags (and
// so their styling) stay as written.
const HEADING_LEVELS = { h1: 2, h2: 3, h3: 3, h4: 4, h5: 5, h6: 6 } as const;

type HeadingTag = keyof typeof HEADING_LEVELS;

const levelled = (Tag: HeadingTag, level: number) => {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const Heading = ({ node, level: _markdownLevel, ...props }: any) => <Tag aria-level={level} {...props} />;
    Heading.displayName = `Markdown${Tag.toUpperCase()}`;
    return Heading;
};

/** Spread into react-markdown's `components` to keep its headings under the page's <h1>. */
export const markdownHeadingComponents = Object.fromEntries(Object.entries(HEADING_LEVELS).map(([tag, level]) => [tag, levelled(tag as HeadingTag, level)])) as Record<HeadingTag, ReturnType<typeof levelled>>;
